import React from 'react';
import '../styles/HeroCard.css';

interface HeroCardProps {
  children: React.ReactNode;
}

const HeroCard: React.FC<HeroCardProps> = ({ children }) => {
  return (
    <div className="hero-card">
      {children}
    </div>
  );
};

export default HeroCard;
